module.exports = __webpack_public_path__ + "static/media/preconfirm-icon.35e07dc7.svg";